import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { WhitelabelService } from './services/whitelabel.service';
import { TranslateService } from './services/translate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: []

})

export class AppComponent {
  appName = 'Process eye';
  showHeader = false;
  private currentTitleKey: string;

    constructor(private whitelabelService: WhitelabelService, private router: Router, private activatedRoute: ActivatedRoute,
      private titleService: Title, private translateService: TranslateService) {
    }

  ngOnInit() {
    this.whitelabelService.initService();
    // Suscribirse a los cambios en el servicio WhitelabelService
    this.whitelabelService.currentWhitelabelObservable.subscribe((whitelabel) => {
      if (whitelabel != '') {
        this.appName = this.whitelabelService.getCurrentAppName();
      }
      this.updatePageTitle();
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute.firstChild;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data;
      })
    ).subscribe((data: any) => {
      this.currentTitleKey = data['title'];
      this.showHeader = !!data['showHeader'];
      this.updatePageTitle();
    });

    this.translateService.LanguageChanged.subscribe(() => this.updatePageTitle());
  }

  private updatePageTitle() {
    const pageTitle = this.currentTitleKey ? this.translateService.translate(this.currentTitleKey) : null;
    this.titleService.setTitle(pageTitle ? `${pageTitle} - ${this.appName}` : this.appName);
  }

}

